export default {
  metalsButton: {
    id: 'rm_modal_highlights_metals_button',
    defaultMessage: 'Metal Library',
  },
  contentButton: {
    id: 'rm_modal_highlights_content_button',
    defaultMessage: 'Content Gallery',
  },
} as const
